// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D2da","badges":"styles_badges__xyyv2"};